module.exports = __webpack_public_path__ + "img/av026.cda99e91.png";